import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable no-nested-ternary */
import { Text, colors, TextDescription, StepperConnector, StepperSection, HSpacer, StepperIconContainer, ContainerVertical, ListSpacer, Title, When } from '@aftersale-next/ui';
import { RenderActionButton } from '../actions/render-action-button';
import * as eventCode from '../../config/constants/event-code';
import { replaceTextUrlWithHtmlLink } from '@aftersale-next/utils';
import styled from 'styled-components';

var selectDotColor = function selectDotColor(code) {
  if (code === eventCode.INIT) {
    return colors.lightGray;
  }

  if (code === eventCode.FAIL || code === eventCode.COURIER_UNKNOWN || code === eventCode.CANCELED || code === eventCode.NECESSARY_ACTION) {
    return colors.orange;
  }

  if (code === eventCode.CONTACT || code === eventCode.REFUSE_RETENTION) {
    return colors.royal;
  }

  return colors.green;
};

var EventDescription = /*#__PURE__*/styled(TextDescription).withConfig({
  displayName: "event-item__EventDescription",
  componentId: "pmcu7c-0"
})(["word-break:break-word;"]);
export default function EventItem(props) {
  var dateInstance = props.date !== 0 ? new Date(props.date) : undefined;
  var date = dateInstance ? dateInstance.toLocaleDateString('pt-BR') : '';
  var time = dateInstance ? dateInstance.toLocaleTimeString('pt-BR') : '';
  return /*#__PURE__*/_jsxs(StepperSection, {
    children: [/*#__PURE__*/_jsxs(ContainerVertical, {
      align: "center",
      justify: "flex-start",
      padding: "".concat(props.isFirst && props.isLast ? 9 : 27, "px 0 0 0"),
      children: [/*#__PURE__*/_jsx(StepperIconContainer, {
        color: selectDotColor(props.code)
      }), !props.disableConnector && /*#__PURE__*/_jsx(StepperConnector, {
        position: props.isFirst ? 'relative' : 'absolute'
      })]
    }), /*#__PURE__*/_jsxs(ContainerVertical, {
      align: "flex-start",
      padding: "0 0 0 20px",
      children: [props.date !== 0 && /*#__PURE__*/_jsxs(Text, {
        children: [date, ' - ', time]
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "2px"
      }), /*#__PURE__*/_jsx(Title, {
        children: props.description
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "2px"
      }), /*#__PURE__*/_jsx(EventDescription, {
        textStyle: "italic",
        children: /*#__PURE__*/_jsx("p", {
          dangerouslySetInnerHTML: {
            __html: props.details ? replaceTextUrlWithHtmlLink(props.details) : ''
          }
        })
      }), /*#__PURE__*/_jsx(When, {
        value: !!props.actions.length,
        children: /*#__PURE__*/_jsx(ContainerVertical, {
          children: /*#__PURE__*/_jsx(ListSpacer, {
            top: "15px",
            gap: "15px",
            children: props.actions.map(function (action) {
              return /*#__PURE__*/_jsx(RenderActionButton, {
                packageId: props.packageId,
                action: action
              });
            })
          })
        })
      }), !props.disableBottomSpacer && /*#__PURE__*/_jsx(HSpacer, {
        space: "25px"
      })]
    })]
  });
}